import { render, staticRenderFns } from "./ModalAddResi.vue?vue&type=template&id=b039c8ea&"
import script from "./ModalAddResi.vue?vue&type=script&lang=js&"
export * from "./ModalAddResi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports